

export default {
  layout: 'empty',
  props: {
    error: {
      type: Object,
      default: null
    }
  },
  head () {
    const titleTranslationKey = this.error.statusCode === 404 ? '404' : 'error'

    return { title: this.$t(titleTranslationKey) }
  }
}
